import * as React from "react";
import { SVGProps } from "react";

export const PUBiconDisabled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={128}
    height={128}
    viewBox="-9 -9 52 52"
    id="svg1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs id="defs1" />
    <g id="layer1">
      <g id="g16">
        <path
          id="circle27"
          style={{
            fill: "currentcolor",
            strokeWidth: 3.70417,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          d="m 16.933333,7.5147868 a 4.360486,4.360486 0 0 0 -2.689241,0.9286255 l 6.12159,6.1215897 a 4.360486,4.360486 0 0 0 0.928109,-2.689758 4.360486,4.360486 0 0 0 -4.360458,-4.3604572 z"
        />
        <path
          id="path17"
          style={{
            fill: "currentcolor",
            strokeWidth: 3.70417,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          d="M 3.5315674,9.3322469 A 4.3604858,4.3604858 0 0 0 3.4881592,9.9430623 4.3604858,4.3604858 0 0 0 7.8491333,14.30352 4.3604858,4.3604858 0 0 0 8.4599487,14.260628 Z"
        />
        <path
          id="path19"
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 3.17499,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          d="M 7.7127075,15.886886 A 7.7129096,5.1419397 0 0 0 0,21.029207 v 5.32319 h 6.5215658 v -3.391008 c 0,-2.434805 1.9389666,-4.586822 4.8363972,-5.802746 L 10.329602,16.130282 A 7.7129096,5.1419397 0 0 0 7.9850423,15.886886 Z m 6.4771245,4.103625 c -1.528354,0.590943 -2.541447,1.69207 -2.541447,2.970878 v 3.391008 h 4.049365 v -4.853968 z"
        />
        <path
          id="path20"
          style={{
            fill: "currentcolor",
            strokeWidth: 3.70417,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          d="m 26.017794,5.5826254 a 4.3604858,4.3604858 0 0 0 -3.916942,2.4445968 c 0.807036,1.0774513 1.287025,2.4108728 1.287025,3.8474468 0,0.487119 -0.05569,0.962431 -0.160113,1.419884 a 4.3604858,4.3604858 0 0 0 2.79003,1.009044 4.3604858,4.3604858 0 0 0 4.360492,-4.3604854 4.3604858,4.3604858 0 0 0 -4.360492,-4.3604862 z"
        />
        <path
          id="path21"
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 3.17499,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          d="m 25.881624,15.886886 a 7.7129096,5.1419397 0 0 0 -3.59978,0.594279 l 1.071253,1.071252 c 1.749075,0.907067 3.05238,2.180763 3.642671,3.642672 l 5.157308,5.157308 h 1.713591 v -5.32319 a 7.7129096,5.1419397 0 0 0 -7.713225,-5.142321 z m -7.712707,8.08271 v 2.382801 h 2.3828 z"
        />
        <path
          id="path28"
          style={{
            fill: "currentcolor",
            stroke: "none",
            strokeWidth: 3.27706,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeDashoffset: 19.1999,
            strokeOpacity: 1,
          }}
          d="m 65.596539,63.25517 a 6.5,6.5 0 0 0 -3.109031,5.545433 v 6.72912 h 11.292066 z"
          transform="matrix(1.1866015,0,0,0.79106765,-65.063571,-31.465059)"
        />
        <rect
          style={{
            fill: "currentcolor",
            strokeWidth: 3.96875,
            strokeLinecap: "square",
            strokeLinejoin: "round",
            strokeDashoffset: 19.1999,
          }}
          id="rect5"
          width={3.96875}
          height={39.6875}
          x={-1.9843727}
          y={4.103601}
          ry={1.984375}
          transform="rotate(-45)"
        />
      </g>
    </g>
  </svg>
);
